export default "__VITE_ASSET__BXpnz8vA__"